<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 1
      h1 Generalidades de los aditivos alimentarios
    
    .tarjeta--bg-img.color-primario-5.rounded-3.p-0.mb-5.overflow-hidden(data-aos="fade-right")
      .row.justify-content-center.align-items-center.mb-0.h-100
        .col-12.col-lg-5.mb-lg-0.mb-3.p-0.align-self-stretch.d-none.d-lg-block
          figure.p-0.m-0.h-100
            img(src="@/assets/curso/temas/tema_1/img_1.png" class="img-fluid w-100 h-100 object-fit-cover").p-0
        .col-12.col-lg-7.p-4
         .row
          .col-12.col-lg-2.mb-0.d-none.d-lg-block
            img(src="@/assets/curso/temas/tema_1/img_2.png", class="img-fluid w-100")
          .col-12.col-lg-10
            p.mb-0 Los aditivos alimentarios son sustancias que se adicionan intencionalmente a los alimentos con fines tecnológicos durante su producción, para mejorar su conservación, aspecto o sabor. Su uso es tan antiguo como la civilización, aunque su regulación y diversidad han evolucionado drásticamente con el propósito de mantener o mejorar las características físicas, químicas y sensoriales del alimento, sin comprometer la salud del consumidor (FAO & OMS, 2015).

    Separador

    .bg_img_1.mb-3

      #t_1_1.titulo-segundo.color-primario
        .h2(data-aos="fade-right") 1.1 Contexto histórico
      .mb-0

      .row.justify-content-center.align-items-center.mb-5
        .col-12.col-lg-3.mb-lg-0.mb-3(data-aos="flip-left")
          figure
            img(src='@/assets/curso/temas/tema_1/img_4.png', class="img-fluid")
        .col-12.col-lg-9
          .row.justify-content-center.align-items-center.mb-3
            .col-12.col-lg-10.mb-lg-0.mb-3(data-aos="fade-right")
              p.mb-0 Desde el Paleolítico, el ser humano ha utilizado aditivos como la sal, el ahumado y el zumo de limón para conservar alimentos. Con el desarrollo de la agricultura y la ganadería, se integraron el azafrán, la sal de nitro y el vinagre para mejorar la palatabilidad y gestionar excedentes.
            .col-12.col-lg-2.mb-lg-0.mb-3.d-none.d-lg-block(data-aos="flip-left")
              figure
                img(src='@/assets/curso/temas/tema_1/img_5.svg', class="img-fluid w-100")
          
          .bloque-texto-b.color-secundario-5.p-4(data-aos='zoom-in-right')
            .bloque-texto-b__texto
              i.fas.fa-quote-left
              p.mb-3 Aunque su uso fue empírico hasta el siglo XVIII, los avances químicos y las demandas industriales del siglo XIX formalizaron el término "aditivo", logrando la aceptación legal de su inocuidad <h4>(Ibáñez, Irigoyen y Torre, 2003)</h4>.
              i.fas.fa-quote-right
          

      
      .row.justify-content-center.align-items-center(data-aos="fade-right")
        .col-12.col-lg-10.mb-5
          .div.tarjeta--bg-img.color-primario-20.rounded-3.p-0.mb-5.overflow-hidden
            .row.justify-content-around.align-items-center.mb-0.h-100
              .col-12.col-lg-2.mb-lg-0.mb-3.p-0.align-self-stretch.d-none.d-lg-block
                figure.p-0.m-0.h-100
                  img(src="@/assets/curso/temas/tema_1/img_6.svg" class="img-fluid w-100").p-0
              .col-12.col-lg-10.p-4.pe-5
                .row.justify-content-between.align-items-center
                  .col.mb-5.mb-sm-0
                    h4.mb-1 Ingrese al siguiente enlace para ampliar información sobre las generalidades de los aditivos alimentarios: 
                  .col-sm-auto
                    a.boton.color-acento-botones(href="https://www.youtube.com/watch?v=v0OVfIJS3UM" target="_blank")
                      span Enlace
                      i.fas.fa-link.me-2
    
      Separador

      #t_1_2.titulo-segundo.color-primario
        .h2(data-aos="fade-right") 1.2 Objetivos y función
      .mb-0

    .bloque-texto-t.justify-content-center.align-items-center.mb-0(data-aos="zoom-in-right")
      .bloque-texto-t__img.mb-0
        img(src='@/assets/curso/temas/tema_1/img_7.png')
      .bloque-texto-t__texto.col-9.mb-0
        p.mb-0 Históricamente, los aditivos han sido esenciales para mejorar la nutrición y asegurar la supervivencia. Actualmente, en las industrias láctea y cárnica, su uso es fundamental para desarrollar productos más duraderos y con propiedades específicas, como los probióticos.
    
    .row.justify-content-center.align-items-center.mb-4
      .col-12.col-lg-9.order-2.order-lg-1(data-aos='zoom-in-right')
        .tarjeta.color-secundario-5.p-3.rounded-0.mb-3
          .row.justify-content-center.align-items-center.mb-0
            .col-lg-1.d-lg-block.d-none(data-aos="zoom-in-right")
              figure
                img(src='@/assets/curso/temas/tema_1/img_8.svg', class="img-fluid")
            .col-12.col-lg-11.mb-0(data-aos="zoom-in-right")
              p.mb-0 Dado que los alimentos son sistemas dinámicos sujetos a cambios físicos y químicos que afectan su calidad, los aditivos permiten preservar sus propiedades sensoriales y corregir su estabilidad. De este modo, se garantiza la durabilidad y las características deseadas en el mercado actual.
        p.mb-0 Con el uso de los aditivos, la industria alimentaria ha pretendido alcanzar objetivos como los siguientes:
      .col-12.col-lg-3.order-1.order-lg-2.mb-3.mb-lg-0(data-aos="zoom-in-right")
        figure
          img(src='@/assets/curso/temas/tema_1/img_9.png', class="img-fluid") 

    .bg_img_2.mb-3
      
      .row.justify-content-center.align-items-center.mb-4
        .col-12.col-lg-10.mb-3
          .titulo-sexto.color-acento-botones
            h5 Figura 1.
            |    Objetivos de los aditivos
          figure(data-aos="flip-left")
            img(src='@/assets/curso/temas/tema_1/img_11.svg', class="img-fluid d-none d-lg-block", alt="Mejorar las caracteríaticas sensoriales y de palatabilidad.- Poner el alimento en las condiciones más adecuadas para su ingestión.- Alargar la vida útil del producto.- Mejorar sus propiedades fisicoquímicas.").mb-5
            img(src='@/assets/curso/temas/tema_1/img_12.svg', class="img-fluid d-block d-lg-none", alt="Mejorar las caracteríaticas sensoriales y de palatabilidad.- Poner el alimento en las condiciones más adecuadas para su ingestión.- Alargar la vida útil del producto.- Mejorar sus propiedades fisicoquímicas.").mb-5
            figcaption Nota. Adaptado de Ibáñez et al, (2003).

      .row.justify-content-center.align-items-center.mb-5
        .col-12.col-lg-4.mb-lg-0.mb-3(data-aos="flip-left")
          figure
            img(src='@/assets/curso/temas/tema_1/img_13.png', class="img-fluid")
        .col-12.col-lg-8(data-aos="fade-right")
          .row.justify-content-center.align-items-center.mb-3
            .col-12.col-lg-12(data-aos="zoom-in-right")
              .cita-decorada
                blockquote.cita-decorada__caja.cita-decorada__caja--fondo-2.p-4
                  .row.justify-content-center.align-items-center
                    .col-2.col-lg-2.d-none.d-lg-block
                      figure
                        img(src='@/assets/curso/temas/tema_1/img_14.svg', class="cita-decorada__imagen-flotante-4")
                    .col-12.col-lg-10
                      p.cita-decorada__texto.mb-2.p-3 Los aditivos alimentarios tienen como objetivos principales evitar el deterioro de los productos tras su producción y mejorar su aceptación comercial mediante una presentación más agradable. Según Ibáñez et al. (2003), sus funciones incluyen conservar, potenciar el sabor, mezclar, espesar, añadir color, mantener la consistencia y calidad, además de compensar carencias nutricionales.
                  
          .tarjeta.color-secundario-5.p-3.rounded-0.mb-3(data-aos="fade-right")
            p.mb-0 Pese a las críticas sobre su impacto en la salud y la artificialidad de la dieta, su uso está justificado al ser fundamentales para la conservación y el manejo de las propiedades organolépticas de los alimentos.
      
      .row.justify-content-center.align-items-center.mb-4(data-aos="fade-right")
        .col-12.col-lg-12.mb-3
          p.mb-5 Además de estas ventajas, los aditivos cumplen funciones específicas tales como:

    .bg_img_3.mb-0
      
      .row.justify-content-center.align-items-center.mb-4
        .col-12.col-lg-10.mb-3
          .titulo-sexto.color-acento-botones(data-aos="fade-right")
            h5 Figura 2.
            |    Funciones específicas de los aditivos
          figure(data-aos="flip-left")
            img(src='@/assets/curso/temas/tema_1/img_16.svg', class="img-fluid d-none d-lg-block", alt="Mantener el pan sin moho.- Evitar que los aliños de la ensalada se separen. - Curar la carne.- Dar a la margarina el color amarillo característico.- Solidificar las mermeladas. ").mb-5
            img(src='@/assets/curso/temas/tema_1/img_17.svg', class="img-fluid d-block d-lg-none", alt="Mantener el pan sin moho.- Evitar que los aliños de la ensalada se separen. - Curar la carne.- Dar a la margarina el color amarillo característico.- Solidificar las mermeladas. ").mb-5
            figcaption Nota. Adaptado de Ibáñez et al, 2003.
    
    .row.justify-content-center.align-items-center.mb-3
    .col-12.col-lg-12(data-aos="zoom-in-right")
      .cita-decorada
        blockquote.cita-decorada__caja.cita-decorada__caja--fondo-1.p-4
          .row.justify-content-center.align-items-center
            .col-12.col-lg-11
              p.cita-decorada__texto.mb-2.p-3 Es fundamental que los aditivos alimentarios cumplan con la legislación vigente y los parámetros internacionales para garantizar la inocuidad y niveles de toxicidad seguros (Ibáñez et al., 2003). Su incorporación en cualquier etapa del proceso busca cumplir funciones tecnológicas, como mejorar la conservación, las propiedades sensoriales y las características físicas del producto (OMS, 2023).
            .col-2.col-lg-1.d-none.d-lg-block
              figure
                img(src='@/assets/curso/temas/tema_1/img_18.svg', class="cita-decorada__imagen-flotante-1")

</template>

<script>
export default {
  name: 'Tema1',
  data: () => ({
    mostrarIndicadorTarjetaAudio: true,
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
